import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Team from './pages/Team';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ServicePage from './pages/ServicePage';
import ProjectPage from './pages/ProjectPage';
import NotFound from './pages/NotFound';

function App() {
  return (
    <HelmetProvider>
      <div>
        <div className="grain-overlay"></div>
        <Navbar />
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<HomePage />} />

          {/* Service Pages*/}
          <Route path="/services/:slug" element={<ServicePage />} />
          
          {/* Project Pages*/}
          <Route path="/portfolio/:slug" element={<ProjectPage />} />

          {/* Team */}
          <Route path="/team" element={<Team />} />

          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />

          {/* Not Found */}
          <Route path="*" element={<NotFound />} />

        </Routes>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
